const {REACT_APP_GOOGLE_API_KEY} = process.env;

const src = `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_API_KEY}&libraries=places`;

export default src;